/**
    * Created by menghao on 2016/4/27.
*/
import Sloth from '../Sloth';
require("./tab.scss")
var $ = require("jquery");

@Sloth.component({
    defaultOptions : {
        current : 0
    }
})


export default class Tab {
    onInit() {
        const obj = this.dom;
        const options = this.options;
        var current = options.current;

        $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
        $(".Tab-content", obj).eq(current).addClass("Tab-content_current");

        $(".Tab-item", obj).click(function () {
            var num = $(this).siblings().andSelf().index(this);
            $(this).addClass("Tab-item_current")
                .siblings().removeClass("Tab-item_current");

            $(".Tab-content", obj).eq(num).addClass("Tab-content_current")
                .siblings().removeClass("Tab-content_current");
        })
    }

}


// module.exports = function (obj, options) {
//     var current = $(options.current);
//
//     $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
//     $(".Tab-content", obj).eq(current).addClass("Tab-content_current");
//
//     $(".Tab-item", obj).click(function () {
//         var num = $(this).siblings().andSelf().index(this);
//         $(this).addClass("Tab-item_current")
//             .siblings().removeClass("Tab-item_current");
//
//         $(".Tab-content", obj).eq(num).addClass("Tab-content_current")
//             .siblings().removeClass("Tab-content_current");
//     })
// }
//
// module.exports.moduleDefault = {
//     current : 0
// }


/** WEBPACK FOOTER **
 ** ./components/Tab/tab.js
 **/